export default __webpack_public_path__ + "static/media/mochimo-pq-logo.0304aae2.svg";